import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import { setCallListFilter } from 'flow/actions/extension-actions';
import SearchBar from 'flow/components/SearchBar';
import CallHistoryListV2 from './CallHistoryListV2';

const CallHistoryV2 = () => {
    const dispatch = useAppDispatch();

    const callFilter = useAppSelector((state) =>
        state.extensions.get('callListFilter', ''),
    );

    useEffect(() => {
        dispatch(setCallListFilter(''));
    }, [dispatch]);

    return (
        <div className="flex min-h-0 flex-1 flex-col bg-gray-100 antialiased">
            <div className="p-3">
                <SearchBar
                    onChange={(value) => {
                        dispatch(setCallListFilter(value));
                    }}
                    initialSearchText={callFilter}
                />
            </div>

            <CallHistoryListV2 />
        </div>
    );
};

export default CallHistoryV2;
